// Register mutators
import './mutators/currentSuggestionsMutators';
import './mutators/initializeScenarioStoreMutator';
import './mutators/resetCurrentSuggestionsMutator';
import './mutators/setIsSuggestionsDropdownVisibleMutator';
import './mutators/setSearchTextMutator';
import './mutators/addSuggestionPillInternalMutator';
import './mutators/setLatestTraceIdMutator';
import './mutators/searchBoxHasFocusMutators';
import './mutators/setSearchTextForSuggestionMutator';
export { default as setLatestRenderedQFTraceId } from './mutators/setLatestRenderedQFTraceId';
import './orchestrators/endSearchConversationOrchestrator';
import './mutators/startSearchMutator';
import './mutators/mapTraceIdToLogicalIdMutator';

// Register orchestrators
import './orchestrators/onSearchInputFocusedOrchestrator';
import './orchestrators/onEnterPressedSearchInputOrchestrator';
import './orchestrators/onSearchTextChangedOrchestrator';
import './orchestrators/startSearchSessionOrchestrator';
import './orchestrators/registerAdditionalQuickActionsOrchestrator';
import './orchestrators/addSuggestionPillOrchestrator';
import './mutators/endSearchConversationMutator';

// Required for actions that depend on them.

// Export selectors, interfaces, enums, constants
export { default as getHighlightTerms } from './selectors/getHighlightTerms';
export { default as getScenarioStore } from './selectors/getScenarioStore';
export { START_MATCH_DELIMITER, END_MATCH_DELIMITER } from './bootSearchConstants';
export { default as SearchScenarioId } from './store/schema/SearchScenarioId';
export { default as SearchProvider } from './store/schema/SearchProvider';
export { SearchBoxContainerHandle } from './types/SearchBoxContainerHandle';
export { InstrumentationContext } from './types/InstrumentationContext';

// Export actions
export { addSuggestionPill } from './actions/addSuggestionPill';
export { clearSearchBox } from './actions/clearSearchBox';
export { downloadFileSuggestion } from './actions/downloadFileSuggestion';
export { exitSearch } from './actions/exitSearch';
export { getSuggestions } from './actions/getSuggestions';
export { resetCurrentSuggestions } from './actions/resetCurrentSuggestions';
export { searchBoxBlurred } from './actions/searchBoxBlurred';
export { searchSessionEnded } from './actions/searchSessionEnded';
export { searchSessionStarted } from './actions/searchSessionStarted';
export { setCurrentSuggestions } from './actions/setCurrentSuggestions';
export { setDisplayedQFRequestTime } from './actions/setDisplayedQFRequestTime';
export { shareFileSuggestion } from './actions/shareFileSuggestion';
export { startSearch } from './actions/startSearch';
export { setLatestTraceId } from './actions/setLatestTraceId';
export { suggestionSelected } from './actions/suggestionSelected';
export { onSearchTextChanged } from './actions/onSearchTextChanged';
export { startSearchSession } from './actions/startSearchSession';
export { endSearchSession } from './actions/endSearchSession';
export { registerAdditionalQuickActions } from './actions/registerAdditionalQuickActions';
export { setSearchTextForSuggestion } from './actions/setSearchTextForSuggestion';
export { endSearchConversation } from './actions/endSearchConversation';
export { onSearchScopeOptionSelected } from './actions/onSearchScopeOptionSelected';
export { getFileSuggestionImmersiveViewSupported } from './actions/getFileSuggestionImmersiveViewSupported';

// Export utils
export { default as getSubstrateSearchScenarioBySearchScenarioId } from './utils/getSubstrateSearchScenarioBySearchScenarioId';
export { default as getXClientFlightsHeaderValue } from './utils/getXClientFlightsHeaderValue';
export { default as is3SServiceAvailable } from './utils/is3SServiceAvailable';
export { default as getSearchBoxIdByScenarioId } from './utils/getSearchBoxIdByScenarioId';

// Export components
export { default as SearchBox } from './components/SearchBox';

// Export selectors
export { default as getSearchBoxWidth } from './selectors/getSearchBoxWidth';
export { default as queryIncludesKQLSuggestion } from './selectors/queryIncludesKQLSuggestion';

export {
    lazyClearSearchBox,
    lazyEndSearchSession,
    lazySetLatestQFRequestId,
    lazySetIsSuggestionsDropdownVisible,
    lazyUpdateIsSuggestionSetComplete,
    lazySetShowSearchBoxInCompactMode,
    lazySetSpellerData,
    SearchBoxDropdown,
    SearchScopePicker,
    lazyGetSuggestionAtIndex,
    lazyIsInSearchMode,
    lazyIsQFRequestIdEqualToLatest,
    lazyIsSearchBoxEmpty,
} from './lazyFunctions';
